<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white bb-none headerRestoreAccrual px-5 pt-5 pb-0">
            <div class="startRestoreAccrual">
                <div class="flipBackHeader has-background-primary-light">
                    <EditPencil class="svgIcon" />
                </div>
                <span class="titleRestoreAccrual ml-2"></span>
            </div>
            <button type="button" class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body p-0 px-5 pb-2 pt-4">
            <p class="tittleBodyModal mb-4">Editar Documento</p>
            <div class="field mb-4" v-for="field in editableFields" :key="field.orderKey">
                <label class="label descBodyModal">{{ field.label }}</label>
                <div class="control">
                    <input class="input" type="text" v-model="formData[field.orderKey]" />
                </div>
            </div>
        </section>
        <footer class="modal-card-foot bt-none has-background-white">
            <button class="button is-flex-grow-3" @click="$emit('close')" aria-label="Cancelar" role="button">
                Cancelar
            </button>
            <button class="button is-primary is-flex-grow-1" @click="saveChanges" :class="{'is-loading': isLoading}" role="button">
                Guardar Cambios
            </button>
        </footer>
    </div>
</template>

<script>
import EditPencil from "@/components/svg/EditPencil.vue";

export default {
    name: "EditDocumentModal",
    components: {
        EditPencil
    },
    props: {
        document: {
            type: Object,
            required: true
        },
        headers: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            formData: {},
            isLoading: false
        }
    },
    computed: {
        editableFields() {
            return this.headers.filter(h => !['emitted_at', 'account', 'mother_account'].includes(h.orderKey));
        }
    },
    mounted() {
        // Construimos formData con todas sus keys de una y lo asignamos completo
        // (en vez de this.$set por key, removido en Vue 3). La reasignación del
        // objeto reactivo deja sus keys reactivas para los v-model.
        const formData = {};
        this.editableFields.forEach(field => {
            const path = field.nestedPath || field.orderKey;
            formData[field.orderKey] = this.getNestedValue(this.document, path);
        });
        this.formData = formData;
    },
    methods: {
        getNestedValue(obj, path) {
            if (!path || !obj) return '';
            return path.split('.').reduce((val, key) => (val && val[key] !== undefined ? val[key] : ''), obj)
        },
        saveChanges() {
            // Emitting event with data to be handled by parent
            this.isLoading = true;
            this.$emit('save', this.formData, () => {
                this.isLoading = false;
                this.$emit('close');
            }, () => {
                this.isLoading = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.modal-card {
    margin: auto !important;
    justify-content: center;
}

.tittleBodyModal {
    color: #101828;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
}

.descBodyModal {
    color: #344054;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.bb-none {
    border-bottom: none;
}

.bt-none {
    border-top: none;
}

.headerRestoreAccrual {
    display: flex;
    border-bottom: none;

    .startRestoreAccrual {
        display: flex;

        .flipBackHeader {
            width: 48px;
            height: 48px;
            padding: 10px;
            justify-content: center;
            align-items: center;
            border-radius: 24px;

            .svgIcon {
                width: 28px;
                height: 28px;
                filter: invert(45%) sepia(87%) saturate(3065%) hue-rotate(151deg) brightness(97%) contrast(101%);
            }
        }

        .titleRestoreAccrual {
            flex: 1;
            color: #101828;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            text-transform: uppercase;
        }
    }

    .delete {
        margin-left: auto;
    }
}
</style>
